(function () {
  function initCarousel(section) {
    if (!section) return;

    const sliderEl = section.querySelector(".review-carousel__slider.swiper");
    if (!sliderEl) return;

    // Prevent double init
    if (sliderEl.classList.contains("swiper-initialized")) return;

    const prevEl = section.querySelector(".review-carousel__nav--prev");
    const nextEl = section.querySelector(".review-carousel__nav--next");

    // pause all videos on slide change
    const pauseAll = () => {
      section.querySelectorAll("video.review-card__video").forEach((v) => {
        try { v.pause(); } catch (e) {}
      });
    };

    // Click video to toggle play/pause
    section.addEventListener("click", (e) => {
      const video = e.target.closest("video.review-card__video");
      if (!video) return;

      if (video.paused) {
        pauseAll();
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    // Wait until Swiper exists
    if (!window.Swiper) {
      console.warn("[ReviewCarousel] Swiper not found. Did you load swiper-bundle.min.js?");
      return;
    }

    // Read settings from data attributes if you want (optional)
    const loop = sliderEl.dataset.loop === "true";
    const spaceBetween = parseInt(sliderEl.dataset.gap || "15", 10);

    new Swiper(sliderEl, {
      loop: loop,
      spaceBetween: spaceBetween,
      speed: 400,
      grabCursor: true,
      slidesPerView: 1.1,
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: spaceBetween },
        1200: { slidesPerView: 4, spaceBetween: spaceBetween }
      },
      navigation: {
        prevEl,
        nextEl
      },
      on: {
        slideChange: pauseAll,
        touchMove: pauseAll
      }
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll(".review-carousel").forEach(initCarousel);
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", () => initAll());

  // Theme editor support
  document.addEventListener("shopify:section:load", (e) => initAll(e.target));
  document.addEventListener("shopify:section:reorder", () => initAll());
})();
